export default __webpack_public_path__ + "images/4a206f5eafd494b79c7c112958664520.svg";